<template>
  <mobialis-notification
    class="alert-primary alert-style-tertiary"
    :class="[alertType, customStyle ? 'custom-style' : 'mb-4']"
    :close-button="false"
  >
    <div class="media" slot="content">
      <img class="notification-img" :class="customStyle ? 'mr-2' : 'mr-1'" alt="" :src="require(`@/assets/${icon}`)" />
      <div class="media-body notification-text">
        {{ text }}
      </div>
    </div>
  </mobialis-notification>
</template>

<script>
export default {
  name: 'Notification',
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'check-circle-green-fill-2.svg',
      required: false,
    },
    alertType: {
      type: String,
      default: 'alert-success',
      required: false,
    },
    customStyle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.alert {
  padding: 14px 20px;
  @media (max-width: 575px) {
    padding: 12px 16px !important;
  }
}
.notification-text {
  color: #4b5863;
  font-size: 14px;
  line-height: 21px;
  @media (max-width: 575px) {
    font-size: 12px;
    line-height: 18px;
    max-width: 100%;
  }
}
.custom-style {
  .notification-text {
    font-weight: 700;
    line-height: 18px;
    margin-left: 7px;
  }
  .notification-img {
    width: 24px;
    margin-top: 8px;
    height: 18.5px;
    @media (max-width: 575px) {
      margin-top: 3px;
    }
  }
}
</style>
